import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import loading from '../loading.svg';
import StationForm from './StationForm';

class ModalForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pro_subscription: false,
            api_key: '',
            secret_key: '',
            name: '',
            serial: '',
            password: '',
            username: '',
            email: '',
            api: 'Zentra',
            download_since: null,
            model: null,
            site: '',
        };

        this.handleChange = this.handleChange.bind(this);
    }


    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    render() {

        let dialog = this.props.visible &&
            <Dialog
                title={this.props.intl.formatMessage({ id: 'app.stations.modelFrom.addStation', defaultMessage: 'Add Station' })}
                onClose={this.props.close}
            >

                <div className='modal-wrap'>
                    <div className='modal-form-wrap'>
                        <StationForm
                            intl={this.props.intl}
                            handleChange={this.handleChange}
                            davisAccounts={this.props.davisAccounts}
                            qampoAccounts={this.props.qampoAccounts}
                            weenatAccounts={this.props.weenatAccounts}
                            prismabAccounts={this.props.prismabAccounts}
                            agroopAccounts={this.props.agroopAccounts}
                            station={this.state}
                            deleteDavisAccount={this.props.deleteDavisAccount}
                            deleteQampoAccount={this.props.deleteQampoAccount}
                            deleteWeenatAccount={this.props.deleteWeenatAccount}
                            deletePrismabAccount={this.props.deletePrismabAccount}
                            deleteAgroopAccount={this.props.deleteAgroopAccount}
                            wiseconnStations={this.props.wiseconnStations}
                            draginoModels={this.props.draginoModels}
                            addStation={this.props.addStation}
                            loadingDevices={this.props.loadingDevices}
                            addingDevice={this.props.addingDevice}
                        />

                    </div>
                    <div style={{ color: 'red', padding: '10px' }}>
                        {this.props.error}
                    </div>
                </div>
                <DialogActionsBar>
                    <button className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md" onClick={this.props.close}>{this.props.intl.formatMessage({ id: 'app.stations.modelFrom.cancel', defaultMessage: 'Cancel' })}</button>
                    {['Wiseconn', 'Ag-Zoom'].indexOf(this.state.api) === -1 &&
                        <button
                            disabled={this.props.addingDevice}
                            className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md"
                            onClick={() => {
                                if (this.state.api === 'Davis') {
                                    this.props.addDavisAccount(this.state);
                                } else if (this.state.api === 'Qampo') {
                                    this.props.addQampoAccount(this.state)
                                } else if (this.state.api === 'Weenat') {
                                    this.props.addWeenatAccount(this.state)
                                } else if (this.state.api === 'Prismab') {
                                    this.props.addPrismabAccount(this.state)
                                } else if (this.state.api === 'Agroop') {
                                    this.props.addAgroopAccount(this.state)
                                } else if (this.state.api === 'Dragino') {
                                    this.props.addDraginoStation(this.state)
                                }
                                else
                                    this.props.addStation(this.state)

                            }}>
                            {this.props.addingDevice ? <img style={{ color: 'gray', width: '25px' }} src={loading} alt='loading'></img> : this.props.intl.formatMessage({ id: 'app.stations.modelFrom.add', defaultMessage: 'Add' })}
                        </button>}
                </DialogActionsBar>
            </Dialog >;
        return (dialog);
    }
}


export default ModalForm;